import React from "react";
import DataGrid, {
  Column,
  MasterDetail,
  Button as ButtonGrid,
  Pager,
  FilterRow,
  Scrolling,
  Paging,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import PropTypes from "prop-types";
import Pagination from "../Pagination/Pagination";
import {
  downloadDataReceiptSvg,
  viewIconDataReceiptSvg,
} from "../../Assets/SVGs/dataReceiptSVGs";
import "./DataGrid.scss";

export const DataReceiptFileTypeDataGrid = ({
  customStore = {},
  selectedFileType,
  expanded,
  viewDataReceipts,
}) => (
  <div className="dataReceiptTable">
    <DataGrid
      dataSource={customStore}
      hoverStateEnabled={true}
      showBorders={true}
      onRowClick={selectedFileType}
      height={340}
      noDataText="No data receipts"
      onRowExpanded={expanded}
    >
      <Paging enabled={true} defaultPageSize={10} />
      <Pager visible={true} displayMode="full" showNavigationButtons={true} />
      <Column dataField="dataReceiptType" caption="File type" />
      <MasterDetail
        enabled={true}
        render={viewDataReceipts}
        noDataText="No data receipts"
      />
    </DataGrid>
  </div>
);
DataReceiptFileTypeDataGrid.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  customStore: PropTypes.object,
  selectedFileType: PropTypes.func.isRequired,
  expanded: PropTypes.func.isRequired,
  viewDataReceipts: PropTypes.func.isRequired,
};

export const DataReceiptsGrid = ({
  pageChangeTrue,
  sendRequestforList,
  setTotalCount,
  viewDataReceiptContent,
  currentPage,
  dataReceiptsCount,
  downloadDataRecieptSasUri,
  pageChanged,
}) => (
  <div className="data-grid-dataReceipt">
    <DataGrid
      dataSource={
        new CustomStore({
          load: () => {
            if (pageChangeTrue) {
              return sendRequestforList("load");
            }
            return setTotalCount().then((res) => res.data);
          },
        })
      }
      noDataText="No data receipts"
      hoverStateEnabled={true}
      showBorders={true}
    >
      <FilterRow visible={true} />
      <Pager showNavigationButtons={true} />
      <Scrolling mode="virtual" />
      <Column dataField="fileName" caption="File name" />
      <Column
        dataField="createdOn"
        caption="Uploaded on"
        format="dd MMM yyyy | HH:mm"
        dataType="date"
      />
      <Column caption="Action" type="buttons" name="dataReceiptButtons">
        <ButtonGrid
          text="view"
          visible={(e) => e.row.data.fileName.includes(".json")}
          onClick={(e) => {
            viewDataReceiptContent(e.row.data);
          }}
        >
          {viewIconDataReceiptSvg}
        </ButtonGrid>

        <ButtonGrid
          text="Download"
          onClick={(e) => {
            downloadDataRecieptSasUri(e.row.data);
          }}
        >
          <span className="downloadIcon">{downloadDataReceiptSvg}</span>
        </ButtonGrid>
      </Column>
    </DataGrid>

    <div>
      <Pagination
        className="DataReceiptPagination"
        currentPage={currentPage}
        totalCount={dataReceiptsCount}
        pageSize={5}
        onPageChange={(page) => pageChanged(page)}
      />
    </div>
  </div>
);

DataReceiptsGrid.propTypes = {
  currentPage: PropTypes.number.isRequired,
  dataReceiptsCount: PropTypes.number.isRequired,
  downloadDataRecieptSasUri: PropTypes.func.isRequired,
  pageChangeTrue: PropTypes.bool.isRequired,
  pageChanged: PropTypes.func.isRequired,
  sendRequestforList: PropTypes.func.isRequired,
  setTotalCount: PropTypes.func.isRequired,
  viewDataReceiptContent: PropTypes.func.isRequired,
};
